import clsx from 'clsx';
import { DividerComponentProps } from './divider-types';

const marginSizes = {
    largest: '2.5rem',
    larger: '2rem',
    default: '1.5rem',
    smaller: '1rem',
    smallest: '0.5rem',
    none: '0',
} as const;

export const Divider = (props: DividerComponentProps) => {
    const marginTop = () => marginSizes[props.marginSizeTop as keyof typeof marginSizes] || marginSizes['default'];
    const marginBottom = () => marginSizes[props.marginSizeBottom as keyof typeof marginSizes] || marginSizes['default'];
    const width = () => props.manualWidth ? `${props.width}%` : '100%';
    const bgClass = () => props.isTransparent ? 'bg-transparent' : 'bg-cvi-border-default';

    if (props.forPdfBuilder) {
        return (
            <div
                class="relative"
                style={{
                    height: `calc(${marginTop()} + ${marginBottom()})`,
                }}
            >
                <div
                    class={clsx('absolute top-1/2 h-px content-[""]', bgClass())}
                    style={{ width: width() }}
                />
            </div>
        );
    }

    return (
        <div
            class={clsx('h-px', bgClass())}
            style={{
                width: width(),
                'margin-top': marginTop(),
                'margin-bottom': marginBottom(),
            }}
        />
    );
};

Divider.parseProps = (atts: any) => {
    return atts;
};
